import { combineReducers } from 'redux';
import { locationDuck } from '@eb/redux-destination';

const {
    reducersByKey: {
        suggestions,
        slug,
        placeId,
        latitude,
        longitude,
        currentPlace,
        currentPlaceParent,
        placeType,
        isWaitingForLocation,
        isUsingCurrentLocation,
        isOnline,
        locationDenied,
    },
    actionTypes: { UPDATE_LOCATION },
} = locationDuck;

const onlineFallback = (state = null, { payload, type }) => {
    let nextState = state;

    if (type === 'SET_ONLINE_FALLBACK_LOCATION') {
        nextState = payload;
    } else if (type === UPDATE_LOCATION && !payload.isOnline) {
        nextState = null;
    }

    return nextState;
};

export default combineReducers({
    onlineFallback,
    suggestions,
    slug,
    latitude,
    longitude,
    placeId,
    placeType,
    isWaitingForLocation,
    isUsingCurrentLocation,
    isOnline,
    locationDenied,
    currentPlace,
    currentPlaceParent,
    topSuggestions: (state = []) => state,
    trendingSearchCities: (state = []) => state,
    cityBlurb: (state = '') => state,
    currentLocationCoordinates: (state = {}) => state,
    h1Prefix: (state = '') => state,
});
